import { render, staticRenderFns } from "./ContratoAdesaoVida.vue?vue&type=template&id=611929cd"
import script from "./ContratoAdesaoVida.vue?vue&type=script&lang=js"
export * from "./ContratoAdesaoVida.vue?vue&type=script&lang=js"
import style0 from "./ContratoAdesaoVida.vue?vue&type=style&index=0&id=611929cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports